import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

class CountdownTimer extends Component {
  static displayName = 'CountdownTimer';

  static propTypes = {
    seconds: PropTypes.number,
    size: PropTypes.number,
    color: PropTypes.string,
    alpha: PropTypes.number,
    onComplete: PropTypes.func
  };

  static defaultProps = {
    size: 300,
    color: '#000',
    alpha: 1
  };

  constructor() {
    super(...arguments);
    this.seconds = 0;
    this.radius = null;
    this.fraction = 0;
    this.content = 0;
    this.canvas = 0;
  }

  componentDidMount() {
    this.seconds = this.props.seconds;
    this.setupTimer();
  }

  componentWillReceiveProps(nextProps) {
    this.seconds = nextProps.seconds;
    this.setupTimer();
  }

  setupTimer() {
    this.setScale();
    this.setupCanvas();
    this.drawTimer();
    this.startTimer();
  }

  setScale() {
    this.radius = this.props.size / 2;
    this.fraction = 2 / this.seconds;
    this.tickPeriod = this.seconds * 1.8;
  }

  setupCanvas() {
    this.canvas = ReactDOM.findDOMNode(this);
    this.ctx = this.canvas.getContext('2d');
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';
    this.ctx.font = `bold ${this.radius / 2}px Arial`;
  }

  updateCanvas() {
    this.clearTimer();
    this.drawTimer();
  }

  startTimer() {
    setTimeout(() => {
      this.tick();
    }, 200);
  }

  tick() {
    const start = Date.now();
    setTimeout(() => {
      const duration = (Date.now() - start) / 1000;
      this.seconds -= duration;

      if (this.seconds <= 0) {
        this.seconds = 0;
        this.handleComplete();
        this.clearTimer();
      } else {
        this.updateCanvas();
        this.tick();
      }
    }, this.tickPeriod);
  }

  handleComplete() {
    if (this.props.onComplete) {
      this.props.onComplete();
    }
  }

  clearTimer() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.drawBackground();
  }

  drawBackground() {
    this.ctx.beginPath();
    this.ctx.globalAlpha = this.props.alpha / 3;
    this.ctx.arc(this.radius, this.radius, this.radius, 0, Math.PI * 2, false);
    this.ctx.arc(
      this.radius,
      this.radius,
      this.radius / 1.1,
      Math.PI * 2,
      0,
      true
    );
    this.ctx.fill();
  }

  drawTimer() {
    const percent = this.fraction * this.seconds + 1.5;
    this.ctx.globalAlpha = this.props.alpha;
    this.ctx.fillStyle = this.props.color;
    this.ctx.fillText(this.seconds.toFixed(2), this.radius, this.radius);
    this.ctx.beginPath();
    this.ctx.arc(
      this.radius,
      this.radius,
      this.radius,
      Math.PI * 1.5,
      Math.PI * percent,
      false
    );
    this.ctx.arc(
      this.radius,
      this.radius,
      this.radius / 1.1,
      Math.PI * percent,
      Math.PI * 1.5,
      true
    );
    this.ctx.fill();
  }

  render() {
    return (
      <canvas
        ref="canvas"
        className="react-countdown-clock"
        width={this.props.size}
        height={this.props.size}
      />
    );
  }
}

export default CountdownTimer;



// WEBPACK FOOTER //
// ./src/js/components/CountdownTimer.js